import * as React from "react"
import {IAdvicePrescription} from "@curefit/care-common";
import { ChangeEvennt } from "react"
import TextInput from "../TextInput"
import {AppPlaceholders} from "../../utils/AppConstants"
import {map as _map} from "lodash"
import TypeAhead, { TypeAheadElement, TypeAheadResults} from "../TypeAhead"

/**
 * Created by aditya on 28/06/18.
 */

export interface CaseSummaryItemEditorProps {
    consultationType?: string,
    item: IAdvicePrescription;
    onDataChange: (update: any) => any,
    fetchStaticLifeStyleData?: (input: string) => Promise<any>
}

class CaseSummaryItemEditor extends React.Component<CaseSummaryItemEditorProps> {
    constructor(props: CaseSummaryItemEditorProps) {
        super(props)
    }

    onLifeStyleTypeAheadChange = (input: string) => {
        let typeAheadResults: TypeAheadResults;
        let typeAheadArray: TypeAheadElement[] = [];
        let updatedItem = {...this.props.item, name: input};
        this.props.onDataChange(updatedItem);
        return this.props.fetchStaticLifeStyleData(input).then((results: any[]): Promise<TypeAheadResults> => {
            if (results.length) {
                _map(results, (lifestyle) => {
                    let typeAheadElement = {
                        value: lifestyle.name,
                        label: lifestyle.displayName
                    }
                    typeAheadArray.push(typeAheadElement);
                })
                typeAheadResults = {options: typeAheadArray, completed: true};
                return Promise.resolve(typeAheadResults);
            } else {
                return Promise.resolve({options: [], completed: false});
            }
        }).catch((error: any) => {
            throw error;
        });
    };

    onLifeStyleTypeAheadSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, name: elem.label};
        this.props.onDataChange(updatedItem);
    };

    onLifeStyleInstructionChange = (event: ChangeEvent<HTMLInputElement>, meta: any) => {
        let updatedItem = Object.assign({}, this.props.item, {instruction: event.target.value});
        this.props.onDataChange(updatedItem);
    };

    render() {
        let lifeStyleName = this.props.item.name !== undefined && this.props.item.name !== null ? this.props.item.name : "";
        let lifeStyleInstruction = this.props.item.instruction !== undefined && this.props.item.instruction !== null ? this.props.item.instruction : "";
        return (
            <div className="case-summary-item-editor" >
                <div className="case-summary-item-editor-gaps">
                    <TypeAhead widgetName={"CaseSummaryItem"} name="case-summary-name" value={lifeStyleName || ""} placeholder={AppPlaceholders.SYMPTOMS_EDITVIEW_NAME} onTypeAheadChange={this.onLifeStyleTypeAheadChange} onTypeAheadSelect={this.onLifeStyleTypeAheadSelect}/>
                </div>
                <div className="case-summary-item-editor-specifics">
                    <TextInput name="case-summary-instructions" value={lifeStyleInstruction} placeholder={AppPlaceholders.SYMPTOMS_EDITVIEW_ATTRIBUTES} onChange={this.onLifeStyleInstructionChange}/>
                </div>
            </div>
        )
    }
}

export default CaseSummaryItemEditor;
